/**
 * Rótulos e leitura de números do módulo Compliance — funções puras, separadas das
 * telas para não quebrar o fast refresh.
 */
import type { Grupo } from '@/api/contracts/compliance'

/** `Pergunta 19` · `Pergunta 20 › 20.2 Sobre a adoção de arquitetura de nuvem`. */
export function rotuloDoGrupo(grupo: Grupo, grupos: readonly Grupo[]): string {
  if (!grupo.paiId) return `Pergunta ${grupo.codigo}`
  const pai = grupos.find((g) => g.id === grupo.paiId)
  return `${pai ? `Pergunta ${pai.codigo} › ` : ''}${grupo.codigo} ${grupo.titulo}`
}

/** Rótulo curto de filtro: `Pergunta 19` para 1º nível, `20.2` para subgrupo. */
export function rotuloCurtoDoGrupo(grupo: Grupo): string {
  return grupo.paiId ? grupo.codigo : `Pergunta ${grupo.codigo}`
}

/** `"0,2"` ou `"0.2"` → `0.2`; `"1.234,5"` → `1234.5`; vazio ou inválido → `null`. */
export function lerNumero(texto: string): number | null {
  const bruto = texto.trim()
  if (bruto === '') return null
  const normalizado = bruto.includes(',') ? bruto.replace(/\./g, '').replace(',', '.') : bruto
  const numero = Number(normalizado)
  return Number.isFinite(numero) ? numero : null
}

/** Um número para dentro de um campo editável, com vírgula. */
export function paraCampo(numero: number): string {
  return String(numero).replace('.', ',')
}

/** A árvore achatada na ordem de leitura: cada raiz seguida dos seus subgrupos. */
export function gruposEmOrdem(grupos: readonly Grupo[]): Grupo[] {
  const porOrdem = (a: Grupo, b: Grupo) => a.ordem - b.ordem
  return grupos
    .filter((g) => g.paiId === null)
    .sort(porOrdem)
    .flatMap((raiz) => [raiz, ...grupos.filter((g) => g.paiId === raiz.id).sort(porOrdem)])
}
